<template>
  <div>
    <z-scroll :options="{eventPassthrough:'vertical'}" direction="horizontal">
      <ul class="horizontal">
        <li class="list-item" :key="index" v-for="(item, index) in videoList.slice(0, 5)">
          <video-show :videoList="videoList" :selectedIndex="index" :video="item"/>
        </li>
      </ul>
    </z-scroll>
  </div>
</template>

<script>
// import native from '@zz-common/native-adapter'
import { Scroll } from '@zz-common/zz-ui'
// import setPicSize from '@zz-app/setPicSize'
// import { lego } from '@zz-common/lego'

import VideoShow from './Video';

export default {
  name: 'VideoPlayer',
  props: {
    videoList: Array
  },
  data() {
    return {
    }
  },
  components: {
    zScroll: Scroll,
    VideoShow
  }
}
</script>

<style scoped lang="less">
  @import 'index.less';
</style>